import Vue from "vue";
import App from "./App.vue";
import { router } from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueTheMask from "vue-the-mask";
import Meta from "vue-meta";
import SweetModal from "sweet-modal-vue/src/plugin.js";

// import VueFileAgent from "vue-file-agent";

require("./plugins/fontawesome");
require("./plugins/vee-validate");
const moment = require("moment");
require("moment/locale/ru");
Vue.use(require("vue-moment"), {
	moment,
});

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

Vue.use(Meta);
Vue.use(VueTheMask);
Vue.use(SweetModal);

require("./plugins/bootstrap");
import "./assets/css/main.css";

new Vue({
	router,
	store,
	vuetify,
	render: (h) => h(App),
}).$mount("#app");
